<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getFileInfo } from '@chatwoot/utils';
import { fileFormatFor } from 'dashboard/helper/legalFileFormat';

import FileIcon from 'next/icon/FileIcon.vue';
import Icon from 'next/icon/Icon.vue';

const { attachment } = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const fileDetails = computed(() => {
  return getFileInfo(attachment?.dataUrl || '');
});

const displayFileName = computed(() => {
  const { base, type } = fileDetails.value;
  const truncatedName = (str, maxLength, hasExt) =>
    str.length > maxLength
      ? `${str.substring(0, maxLength).trimEnd()}${hasExt ? '..' : '...'}`
      : str;

  return type
    ? `${truncatedName(base, 12, true)}.${type}`
    : truncatedName(base, 14, false);
});

// DEFEITO CORRIGIDO: este componente tinha o PROPRIO mapa de cor por formato
// de arquivo, com 24 hexadecimais cravados dentro de classes utilitarias
// (`text-[#2F265F]`, `dark:text-[#D6E1FF]`...). O produto ja tem um: o GED usa
// `helper/legalFileFormat.js` com as classes `.fmt--*`, e a cor la e a do
// PROGRAMA que abre o arquivo — vermelho Acrobat, azul Word, verde Excel.
// Eram duas verdades para a mesma coisa: o mesmo `.docx` saia azul-indigo no
// chip da conversa e azul-Word no GED.
const formatoDoArquivo = computed(() =>
  fileFormatFor(fileDetails.value.name || fileDetails.value.type)
);
</script>

<template>
  <div
    class="h-9 bg-n-alpha-white gap-2 overflow-hidden items-center flex px-2 rounded-lg border border-n-container"
  >
    <FileIcon class="flex-shrink-0" :file-type="fileDetails.type" />
    <span
      v-tooltip.top="fileDetails.name"
      class="flex-1 min-w-0 text-sm max-w-36"
      :class="`fmt-tinta fmt--${formatoDoArquivo.tone}`"
    >
      {{ displayFileName }}
    </span>
    <a
      v-tooltip="t('CONVERSATION.DOWNLOAD')"
      class="flex-shrink-0 size-9 grid place-content-center cursor-pointer text-n-slate-11 hover:text-n-slate-12 transition-colors"
      :href="attachment.dataUrl"
      rel="noreferrer noopener nofollow"
      target="_blank"
    >
      <Icon icon="i-ph-download-simple" />
    </a>
  </div>
</template>
